module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_fudan-df25b93097422a01915c7ea04e0e09db.png";